import { computed, defineComponent, ref, watch } from 'vue';
import { UserService } from '@/services/user.service';
import { useService } from '@kaokei/use-vue-service';
import HomeHeader from './components/HomeHeader.vue';
import HomeAbout from './components/HomeAbout.vue';
import HomeFooter from './components/HomeFooter.vue';
import FixedButtonGroup from '@/components/FixedButtonGroup.vue';
import SpecialActiveHeader from './components/SpecialActiveHeader.vue';
import { SHOW_BRAND } from '@/utils';
import { useRoute } from 'vue-router';
import { environment, isInIframe } from '@/utils/environment';
import { winTopPostMessage } from '@/utils/topWindowBridge';
import { onUnmounted } from 'vue';
export default defineComponent({
  name: 'Layout',
  components: {
    HomeHeader: HomeHeader,
    HomeAbout: HomeAbout,
    HomeFooter: HomeFooter,
    FixedButtonGroup: FixedButtonGroup,
    SpecialActiveHeader: SpecialActiveHeader
  },
  setup: function () {
    var userService = useService(UserService);
    /**
     * ============================================
     * 需求：https://project.feishu.cn/ht-poject/story/detail/14341910
     * 需要根据活动id展示不同的HomeHeader，活动结束之后可删除
     */
    var specialActiveList = environment === 'production' ? [830, 1093] : [187, 233];
    var currentItemId = ref(''); // 获取当前ItemDetail页面的活动id
    var route = useRoute();
    var isTopWindow = computed(function () {
      return userService.inIframe === false;
    });
    // 下面这个是校验在不在iframe中的配置
    var InIframe = isInIframe();
    userService.setIframeState(InIframe);
    watch(function () {
      return route.name;
    }, function (visible) {
      if (visible === 'ItemDetail') {
        currentItemId.value = route.params.id;
      } else if (visible === 'ActivityDetail') {
        currentItemId.value = route.params.itemId;
      } else {
        currentItemId.value = '';
      }
    }, {
      immediate: true
    });
    // ============================================
    winTopPostMessage({
      method: 'amIInIframeEnv'
    });
    var msgCallback = function (ev) {
      var eventData = ev.data || {};
      if (eventData.method === 'youAreInIframeEnv') {
        userService.setIframeState(true);
        window.removeEventListener('message', msgCallback);
      }
    };
    window.addEventListener('message', msgCallback);
    onUnmounted(function () {
      window.removeEventListener('message', msgCallback);
    });
    return {
      userService: userService,
      SHOW_BRAND: SHOW_BRAND,
      currentItemId: currentItemId,
      specialActiveList: specialActiveList,
      isTopWindow: isTopWindow
    };
  }
});